import { takeLatest } from 'redux-saga'
import { put } from 'redux-saga/effects'

import callAny from './helpers/call_any'
import actionTypes from 'redux/actions/actionTypes'
import navigationMenuActions from 'redux/actions/navigationMenuActions'
import { navigationMenuSync } from 'sync'
import formatError from './helpers/error_formatter'

function *getNotificationPreferencesData() {
	try {
		const response = yield callAny(
			navigationMenuSync.getNotificationPreferencesData
		)
		yield put(
			navigationMenuActions.notificationPreferencesFetched(
				response.payload.notifications
			)
		)
	} catch (error) {
		const serverError = formatError(error)
		yield put(
			navigationMenuActions.notificationPreferencesFailed(serverError)
		)
	}
}

function *updateEmailNotification(action) {
	try {
		yield callAny(
			navigationMenuSync.updateEmailNotification,
			action.value
		)
		yield put(navigationMenuActions.updateEmailNotificationSuccess())
	} catch (error) {
		const serverError = formatError(error)
		yield put(
			navigationMenuActions.updateEmailNotificationFailed(serverError)
		)
	}
}

export default [
	takeLatest(
		actionTypes.NAVIGATION_MENU_NOTIFICATION_PREFERENCES_INITIALIZE,
		getNotificationPreferencesData
	),
	takeLatest(
		actionTypes.NAVIGATION_MENU_NOTIFICATION_PREFERENCES_EMAIL_NOTIFICATION_ENABLED,
		updateEmailNotification
	),
]

export {
	getNotificationPreferencesData,
	updateEmailNotification,
}
